import { Button, Card, Checkbox, Col, ConfigProvider, Flex, Modal, Row } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../styles/ConsentStyle.module.css";
// import "../styles/ConsentStyle.module.css";
import { Alert } from "components/elements";
import dayjs from "dayjs";
import { storage } from "lib";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { generateRandomString } from "utils/helper";
import { getEmploymentInformation } from "../../employee/services/employeeApi";
import { setCurrentEmployment, setIsLoading } from "../../employee/slices/employeeSlice";
import { getRequestOtp } from "../services/webAppApi";

const useConsent = () => {
    const p6 = "ข้อตกลงเเละเงื่อนไข"
    const Header = "หนังสือยินยอม"
    const dispatch = useDispatch()
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    console.log("location", location);

    const allChecked = isChecked1 && isChecked2;

    const generalInfo = useSelector(
        (state) => state.employee.currentEmployment
    );

    const currentEmployee = storage.sessionStorage.getItem("currentEmployee");
    const currentCompany = storage.sessionStorage.getItem("currentCompany");

    const { isLoading, profile } = useSelector((state) => state.webapp);


    const requestOtp = async (params, cb = () => { }) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getRequestOtp({
                ...params,
                requestId: generateRandomString(),
                creditUsage: location?.state?.creditUsage,
                productCode: "BE0001",
                mobileNumber: profile.mobileNumber
            });
            // if (response.data?.)
            console.log("statsu ", response.data?.content);
            cb(response.data?.content)
        } catch (error) {
            console.log("error", error);
            Modal.error({ content: error?.data?.status?.description })
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    const getEmploymentInfoCallback = useCallback(
        async () => {
            try {
                dispatch(setIsLoading(true));
                const response = await getEmploymentInformation({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    visible: false,
                    edit: false
                });
                dispatch(setCurrentEmployment(response.data || {}));
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentEmployee, currentCompany]
    );

    useEffect(() => {
        getEmploymentInfoCallback()
    }, [getEmploymentInfoCallback])

    console.log("testttttttttttttt log", profile);


    function preconsent() {
        return (

            <Flex vertical style={{ color: "#909090", textAlign: "right", justifyContent: "center", alignContent: "center", height: "20vh" }}>
                <span>บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด</span>
                <span>3 อาคารพร้อมพันธุ์ 3 ชั้นที่ 9 ห้องเลขที่ 912</span>
                <span>ซอย ลาดพร้าว 3 แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900</span>
            </Flex>

        )
    }
    function consent1() {
        return (
            <Flex vertical>
                <Flex vertical style={{ color: "#909090", textAlign: "center" }}>
                    <span>{dayjs().format("D MMMM BBBB")}</span>
                </Flex>
                <span style={{ textAlign: "justify", textIndent: "5%", color: "#909090", height: "30vh", justifyContent: "center", alignContent: "center" }}>
                    เพื่อประโยชน์ของข้าพเจ้าในการสมัคร be cash เบิกเงินสดล่วงหน้าเเละเพื่ออำนวยความสะดวกเเก่ข้าพเจ้า ในการชำระคืน be cash เบิกเงินสดล่วงหน้า รวมทั้งปฎิบัติ ตามข้อตกลงเเละเงื่อนไขตามสัญญา be cash เบิกเงินสดล่วงหน้า ต่อบริษัท ไบร์ต เอ็คซ์เพิร์ท จำกัด
                    ข้าพเจ้า {" " + generalInfo?.name + " " + generalInfo?.surName + " "}
                    เป็นพนักงาน/ลูกจ้างของ บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด ตำแหน่ง {generalInfo?.position?.name + " "}
                    ตกลงให้ความยินยอมเเก่นายจ้างเเละตัวเเทนของนายจ้าง ในการดำเนินการต่อไปนี้
                </span>
            </Flex>
        )
    }
    function consent2() {
        return (
            <Row style={{ padding: "2%", color: "#909090" }}>
                <ol style={{ paddingInlineStart: "5%", lineHeight: "1.5" }}>
                    <li style={{ marginBottom: "1vh" }}>
                        ข้าพเจ้าตกลงและยินยอมให้นายจ้างและตัวแทนของนายจ้างทำการหักเงินค่าจ้าง ค่าล่วงเวลา
                        ค่าทำงานในวันหยุด ค่าล่วงเวลาในวันหยุด และค่าตอบแทนอื่นใด รวมถึงเงินค่าชดเชยการเลิกจ้างของข้าพเจ้า
                        เพื่อใช้ในการชำระคืนหนี้ของข้าพเจ้า (ในฐานะผู้กู้) ตามสัญญา be Cash เบิกเงินสดล่วงหน้า
                        ให้แก่บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด (ในฐานะผู้ให้กู้)
                    </li>
                    <li style={{ marginBottom: "1vh" }}>
                        ข้าพเจ้าตกลงและยินยอมว่าในการหักเงินค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่าล่วงเวลาในวันหยุดของข้าพเจ้า
                        โดยนายจ้าง และตัวแทนของนายจ้าง เพื่อใช้ในการชำระคืนหนี้ของข้าพเจ้า (ในฐานะผู้กู้)
                        ตามสัญญา be Cash เบิกเงินสดล่วงหน้า ให้แก่บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด (ในฐานะผู้ให้กู้) ข้างต้นนั้น สามารถหักได้ ดังต่อไปนี้:
                    </li>
                </ol>
            </Row>
        )
    }
    function consent3() {
        return (
            <Flex vertical>
                <span style={{ textAlign: "justify", color: "#909090", }}>
                    2.1. หักได้เกินกว่าร้อยละ 10 ของจำนวนรวมของค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่า
                    ล่วงเวลาในวันหยุดของข้าพเจ้าที่ข้าพเจ้ามีสิทธิได้รับตามกำหนดเวลาจ่ายเงินดังกล่าว และ

                </span>
            </Flex>
        )
    }
    function consent4() {
        return (
            <Flex vertical>
                <span style={{ textAlign: "justify", color: "#909090", }}>

                    2.2. หักได้เกินกว่าร้อยละ 20 ของจำนวนรวมของค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่า
                    ล่วงเวลาในวันหยุดของข้าพเจ้าที่ข้าพเจ้ามีสิทธิได้รับ เมื่อรวมกับเงินที่หักเพื่อ (ก) ชำระค่า
                    บำรุงสหภาพแรงงานตามข้อบังคับของสหภาพแรงงาน (ข) ชำระหนี้สินสหกรณ์ออมทรัพย์
                    หรือสหกรณ์อื่นที่มีลักษณะเดียวกันกับสหกรณ์ออมทรัพย์หรือหนี้ที่เป็นไปเพื่อสวัสดิการที่
                    เป็นประโยชน์แก่ลูกจ้างฝ่ายเดียว โดยได้รับความยินยอมล่วงหน้าจากลูกจ้าง (ค) เป็นเงิน
                    ประกันความเสียหายในการทำงานตามมาตรา 10 แห่งพระราชบัญญัติคุ้มครองแรงงาน หรือ
                    ชดใช้ค่าเสียหายให้แก่นายจ้าง ซึ่งลูกจ้างได้ กระทำโดยจงใจหรือประมาทเลินเล่ออย่าง
                    ร้ายแรง โดยได้รับความยินยอมจากลูกจ้าง (ง) เป็นเงินสะสมตามข้อตกลงเกี่ยวกับกองทุน
                    เงินสะสม
                </span>
            </Flex>
        )
    }
    function checkboxFooter() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                padding: 0,
                width: "100%",
                borderRadius: 0,

            }} styles={{
                body: {
                    paddingBottom: "3vh"
                }
            }}>

                {isPortrait ? <>
                    <Flex vertical style={{}}>
                        <Flex vertical style={{ paddingLeft: "2vh", paddingRight: "2vh" }}>
                            <Row style={{}}>
                                <Col span={22} style={{ color: "#6D6D6D" }}>
                                    <Flex vertical style={{ color: "#6D6D6D", fontSize: "1.7vh" }}>
                                        <span>ข้อตกลงและเงื่อนไข</span>
                                        <span>ข้าพเจ้าได้อ่านและเข้าใจข้อตกลงตกลง</span>
                                        <span>และเงื่อนไขของการหักเงินเดือนเป็นอย่างดีแล้วทุกประการ</span>
                                    </Flex>
                                </Col>
                                <Col span={2} style={{

                                    alignSelf: "center",
                                    textAlignLast: "center"
                                }}>
                                    <ConfigProvider
                                        theme={{
                                            token: {
                                                borderRadiusSM: "50%",
                                                colorPrimary: "#2FD159",
                                                colorPrimaryBorder: "#2FD159",
                                                colorPrimaryHover: "#2FD159",
                                            },
                                        }}
                                    ><Checkbox className={styles.border}
                                        checked={isChecked1}
                                        onChange={() => setIsChecked1(!isChecked1)} />
                                    </ConfigProvider></Col>
                            </Row>
                            <Row style={{ height: "5vh", justifyContent: "center", alignContent: "flex-end" }}>
                                <Col span={22} style={{ color: "#6D6D6D" }}>
                                    <Flex vertical style={{ fontSize: "1.7vh" }}>
                                        <span>ข้าพเจ้าขอยอมรับและยินยอมให้บริษัทฯ </span>
                                        <span>หักเงินเดือนของข้าพเจ้าเพื่อหักชำระหนี้เงินเบิกล่วงหน้าได้</span>
                                    </Flex>
                                </Col>
                                <Col span={2} style={{
                                    alignSelf: "center",
                                    textAlignLast: "center"
                                }}>
                                    <ConfigProvider
                                        theme={{
                                            token: {
                                                borderRadiusSM: "50%",
                                                colorPrimary: "#2FD159",
                                                colorPrimaryBorder: "#2FD159",
                                                colorPrimaryHover: "#2FD159",
                                            },
                                        }}
                                    >
                                        <Checkbox className={styles.border}
                                            checked={isChecked2}
                                            onChange={() => setIsChecked2(!isChecked2)}
                                        />
                                    </ConfigProvider></Col>
                            </Row>
                        </Flex>
                        <Row style={{ height: "8vh", justifyContent: "center", alignContent: "center" }}>
                            <Col span={11} style={{ textAlign: "right", }}>
                                <Button onClick={() => navigate("/webapp/product")} style={{ borderRadius: "2vh", width: "11vh", fontSize: "1.7vh" }} disabled={allChecked}>ไม่ยอมรับ</Button>
                            </Col>
                            <Col span={2}></Col>
                            <Col span={11} style={{ textAlign: "left", }}>
                                <Button onClick={async () => {
                                    async function cb(params) {
                                        navigate("/webapp/otp", { state: { creditUsage: location?.state?.creditUsage, ...params } })
                                    }
                                    requestOtp(null, cb)
                                }} style={{ borderRadius: "2vh", backgroundColor: allChecked ? "#2FD159" : "", color: allChecked ? "white" : "", width: "11vh", fontSize: "1.7vh", }} disabled={!allChecked}>ยอมรับ</Button>
                            </Col>

                        </Row>

                    </Flex></> :
                    <Flex vertical style={{}}>
                        <Flex vertical style={{ paddingLeft: "2vh", paddingRight: "2vh" }}>
                            <Row style={{}}>
                                <Col span={22} style={{ color: "#6D6D6D" }}>
                                    <Flex vertical style={{ color: "#6D6D6D", fontSize: isPortrait ? "1.7vh" : "1.7vw" }}>
                                        <span>ข้อตกลงและเงื่อนไข</span>
                                        <span style={{ textAlign: "justify" }}>ข้าพเจ้าได้อ่านและเข้าใจข้อตกลง และเงื่อนไขของการหักเงินเดือน เป็นอย่างดีแล้วทุกประการ</span>
                                    </Flex>
                                </Col>
                                <Col span={2} style={{

                                    alignSelf: "center",
                                    textAlignLast: "center"

                                }}>
                                    <ConfigProvider
                                        theme={{
                                            token: {
                                                borderRadiusSM: "50%",
                                                colorPrimary: "#2FD159",
                                                colorPrimaryBorder: "#2FD159",
                                                colorPrimaryHover: "#2FD159",
                                            },
                                        }}
                                    ><Checkbox className={styles.border}
                                        checked={isChecked1}
                                        onChange={() => setIsChecked1(!isChecked1)} />
                                    </ConfigProvider></Col>
                            </Row>
                            <Row style={{ height: "5vh", justifyContent: "center", alignContent: "flex-end" }}>
                                <Col span={22} style={{ color: "#6D6D6D" }}>
                                    <Flex vertical style={{ color: "#6D6D6D", fontSize: isPortrait ? "1.7vh" : "1.7vw" }}>
                                        <span style={{ textAlign: "justify" }}>ข้าพเจ้าขอยอมรับและยินยอมให้บริษัทฯ หักเงินเดือนของข้าพเจ้า เพื่อหักชำระหนี้เงินเบิกล่วงหน้าได้
                                        </span>
                                    </Flex>
                                </Col>
                                <Col span={2} style={{
                                    alignSelf: "center",
                                    textAlignLast: "center"
                                }}>
                                    <ConfigProvider
                                        theme={{
                                            token: {
                                                borderRadiusSM: "50%",
                                                colorPrimary: "#2FD159",
                                                colorPrimaryBorder: "#2FD159",
                                                colorPrimaryHover: "#2FD159",
                                            },
                                        }}
                                    >
                                        <Checkbox className={styles.border}
                                            checked={isChecked2}
                                            onChange={() => setIsChecked2(!isChecked2)}
                                        />
                                    </ConfigProvider></Col>
                            </Row>
                        </Flex>
                        <Row style={{ height: isPortrait ? "8vh" : "10vh", justifyContent: "center", alignContent: "center" }}>
                            <Col span={11} style={{ textAlign: "right", }}>
                                <Button onClick={() => navigate("/webapp/product")} style={{ borderRadius: isPortrait ? "2vh" : "4vw", width: isPortrait ? "11vh" : "11vw", fontSize: isPortrait ? "1.7vh" : "1.7vw" }} disabled={allChecked}>ไม่ยอมรับ</Button>
                            </Col>
                            <Col span={2}></Col>
                            <Col span={11} style={{ textAlign: "left", }}>
                                <Button onClick={() => {
                                    async function cb(params) {
                                        navigate("/webapp/otp", { state: { creditUsage: location?.state?.creditUsage, ...params } })
                                    }
                                    requestOtp(null, cb)
                                }} style={{
                                    borderRadius: isPortrait ? "2vh" : "4vw",
                                    backgroundColor: allChecked ? "#2FD159" : "", color: allChecked ? "white" : "",
                                    width: isPortrait ? "11vh" : "11vw", fontSize: isPortrait ? "1.7vh" : "1.7vw",
                                }} disabled={!allChecked}>ยอมรับ</Button>
                            </Col>

                        </Row>

                    </Flex>
                }
            </Card>
        )
    }

    return {
        p6,
        Header,
        preconsent,
        consent1,
        consent2,
        consent3,
        consent4,
        checkboxFooter,

    }
}
export default useConsent;